import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  SectionContainer,
  SectionTitle,
  SectionDetails,
} from '../../shared/sectionable/styles';
import Card from './fund-components/card';

const FundContainer = styled(SectionContainer)`
  margin-top: ${props => (props.theme.isMobile ? 0 : 56)}px;
`;

export default function Fund({ company, funds }) {
  return (
    <FundContainer>
      <SectionTitle>
        Invest with&nbsp;
        {company.name}
      </SectionTitle>
      <SectionDetails>
        {funds.slice(0, 4).map(fund => <Card company={company} fund={fund} />)}
      </SectionDetails>
    </FundContainer>
  );
}

Fund.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  funds: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      publicUrl: PropTypes.string.isRequired,
    }),
  ),
};

Fund.defaultProps = { funds: [] };
